import React from 'react'
import MobileDrawer from '../MobileComponents/MobileDrawer'
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import { blue } from '@mui/material/colors';
import avtar from "../../assets/images/Profile-Picture.jpg";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

function MobileResidentDirectory() {
    const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
    <div>
        <div className="drawerFixedPatch"></div>
        <div className="drawerWithTop">
            <MobileDrawer />
            <h1>Resident Directory</h1>
        </div>
    </div>
    <div className='topSpace'></div>
    <div className='SpecificSpMainDiv'>
        <div className='SearchSortDivTab'>
            <input type='text' placeholder='Search' />
            <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className='ResidDirMainView'>
            <div className='ResiDirView'>
                <div className="ImageViewRound">
                <img src={avtar} className="useImage" alt='altimg'/>
                </div>
                <p className='ResiDirTxt'>FName Lname</p>
                <div className='ResiTagView'>
                    <p className='ResiTagTxt'>Chairman</p>
                </div>
                <p className='ResiAptTxt'>Test Soc/Wing A/F-101</p>
                <div className='ResiPhoneTagView'>
                    <LocalPhoneIcon sx={{fontSize:16, color:'#ffffff'}}/>
                    <p className='ResiPhoneTagTxt'>98745612307</p>
                </div>
            </div>
            <div className='ResiDirView'>
                <div className="ImageViewRound">
                <img src={avtar} className="useImage" alt='altimg'/>
                </div>
                <p className='ResiDirTxt'>FName Lname</p>
                <div className='ResiTagView'>
                    <p className='ResiTagTxt'>General Manager</p>
                </div>
                <p className='ResiAptTxt'>Test Soc/Wing A/F-101, Soc/Wing A/F-101</p>
                <div className='ResiPhoneTagView'>
                    <LocalPhoneIcon sx={{fontSize:16, color:'#ffffff'}}/>
                    <p className='ResiPhoneTagTxt'>98745612307</p>
                </div>
            </div>
            <div className='ResiDirView'>
                <div className="ImageViewRound">
                <img src={avtar} className="useImage" alt='altimg'/>
                </div>
                <p className='ResiDirTxt'>FName Lname</p>
                <div className='ResiTagView'>
                    <p className='ResiTagTxt'>General Manager</p>
                </div>
                <p className='ResiAptTxt'>Test Soc/Wing A/F-101, Soc/Wing A/F-101</p>
                <div className='ResiPhoneTagView'>
                    <LocalPhoneIcon sx={{fontSize:16, color:'#ffffff'}}/>
                    <p className='ResiPhoneTagTxt'>98745612307</p>
                </div>
            </div>
            <div className='ResiDirView'>
                <div className="ImageViewRound">
                <img src={avtar} className="useImage" alt='altimg'/>
                </div>
                <p className='ResiDirTxt'>FName Lname</p>
                <div className='ResiTagView'>
                    <p className='ResiTagTxt'>General Manager</p>
                </div>
                <p className='ResiAptTxt'>Test Soc/Wing A/F-101, Soc/Wing A/F-101</p>
                <div className='ResiPhoneTagView'>
                    <LocalPhoneIcon sx={{fontSize:16, color:'#ffffff'}}/>
                    <p className='ResiPhoneTagTxt'>98745612307</p>
                </div>
            </div>
        </div>
    </div>
    </div>
  )
}

export default MobileResidentDirectory